import { RadioGroup } from "@/components/ui/radio";
import i18n from 'i18n-js';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalFrame from '@/components/basic/ModalFrame';
import RadioButton from '@/components/basic/RadioButton';
import { changeSettings } from "@/stores/mainSlice";

export default function ModalColor({ showModal, setShowModal }) {
    const dispatch = useDispatch()

    const [previousColor, setPreviousColor] = useState(useSelector((state) => state.settings.inAColor || 0) + '')
    const [color, setColor] = useState(previousColor)

    const selectColor = (color) => {
        dispatch(changeSettings({ settings: {inAColor: color} }))
        setColor('' + color)
    }

    const onClose = (isOk) => {
        setShowModal(false)
        if (isOk) {
            setPreviousColor(color)
        } else {
            setColor(previousColor)
            dispatch(changeSettings({ settings: {inAColor: previousColor} }))
        }
    }

    return (
        <ModalFrame title='appSettings.color' text='modalColor.text' showModal={showModal} onClose={onClose}>
            <RadioGroup value={color} name='ColorRadioGroup' accessibilityLabel={i18n.t('modalColor.text')} onChange={nextColor => { selectColor(nextColor) }} className="mr-4 w-[100%]">
                <RadioButton onPress={selectColor} text='modalColor.blue' variant='solid' bg='bg-ina-blue' value='0' />
                <RadioButton onPress={selectColor} text='modalColor.green' variant='solid' bg='bg-ina-green' value='1' />
                <RadioButton onPress={selectColor} text='modalColor.yellow' variant='solid' bg='bg-ina-yellow' value='2' />
                <RadioButton onPress={selectColor} text='modalColor.orange' variant='solid' bg='bg-ina-orange' value='3' />
                <RadioButton onPress={selectColor} text='modalColor.red' variant='solid' bg='bg-ina-red' value='4' />
            </RadioGroup>
        </ModalFrame>
    );
}